import type DocumentSettingsFormData from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/FormData/DocumentSettingsFormData';
import SectionCard from '@Guidelines/Component/SectionCard';
import { css } from '@emotion/react';
import * as React from 'react';
import { InputText } from '@verclam/ui-kit';

const gridStyle = css`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
	gap: 0.875rem;
`;

type Props = {
	readonly settings: DocumentSettingsFormData;
	readonly documentTypeLabel: string;
	readonly onChange: React.Dispatch<React.SetStateAction<DocumentSettingsFormData>>;
};

/** The document's type (fixed once added) and the label it is displayed under. */
const DocumentSection: React.FC<Props> = ({ settings, documentTypeLabel, onChange }) => {
	const handleLabelChange = React.useCallback(
		(value: string) => {
			onChange((current) => current.setLabel(value));
		},
		[onChange],
	);

	return (
		<SectionCard title="Document">
			<div css={gridStyle}>
				<InputText name="documentType" label="Type de document" value={documentTypeLabel} disabled />
				<InputText
					name="label"
					label="Libellé affiché"
					subLabel="Ce que voit le professionnel dans la préparation."
					placeholder={documentTypeLabel}
					value={settings.label}
					onChange={handleLabelChange}
					errorMessage={settings.getValidationMessage('label')}
					isFormFieldValid={settings.isValid('label')}
				/>
			</div>
		</SectionCard>
	);
};

export default DocumentSection;
